import generalApi from "./apiCalls/generalApi";
import sadminApi from "./apiCalls/sadminApi";
import automationsApi from "./apiCalls/automationsApi";
import mlApi from "./apiCalls/mlApi";
import stepApi from "./apiCalls/stepApi";

export default {
  generalApi: generalApi,
  sadminApi: sadminApi,
  automationsApi: automationsApi,
  mlApi: mlApi,
  stepApi: stepApi,
};
